import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-loading-list',
  templateUrl: './loading-list.component.html',
  styleUrls: ['./loading-list.component.scss']
})
export class LoadingListComponent implements OnInit {
  @Input() isLoading = false;
  @Input() totalRegistros = 10;


  constructor() { }

  ngOnInit(): void {

  }


}
